exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adPlayer[data-v-21def1e9]{pointer-events:none}", ""]);

// exports
